var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"back"},[_c('el-button',{attrs:{"type":"primary","icon":"el-icon-arrow-left","plain":""},on:{"click":_vm.back}},[_vm._v("返回")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }